class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.detailsElements = this.querySelectorAll('details');
    this.megaMenuTimer = null; 
    this.detailsElements.forEach(details => {
      const content = details.querySelector('summary').nextElementSibling;
      const menuShowFunction = details.getAttribute('menu-show-function');
      const submenus = details.querySelectorAll('.header__submenu--inner');
      submenus.forEach(submenu => {
        submenu.style.right = `-${submenu.offsetWidth}px`;
      });

      if (menuShowFunction === 'click') {
        // if(details.id.includes("Details-HeaderSubMenu-")){
        //   return;
        // }
        details.addEventListener('focusout', this.onFocusOut.bind(this, details));
        details.addEventListener('toggle', this.onToggle.bind(this));
      } else if (menuShowFunction === 'hover') {
        // if(details.id.includes("Details-HeaderSubMenu-")){
        //   return;
        // }
        details.addEventListener('mouseenter', this.onMouseEnter.bind(this, details));
        details.addEventListener('mouseleave', (event) => this.onMouseLeave(event, details));
      }
    });
  }

  onFocusOut(details) {
    setTimeout(() => {
      if (!details.contains(document.activeElement)) this.close(details);
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  onMouseEnter(details) {
    if (details.classList.contains('mega-menu') && this.megaMenuTimer) {
      clearTimeout(this.megaMenuTimer);
      this.megaMenuTimer = null;
    }

    if (!details.hasAttribute('open')) {
      const submenus = details.querySelectorAll('.header__submenu, .mega-menu__content');
      submenus.forEach(submenu => {
        submenu.style.animation = 'none';
        submenu.offsetHeight; 
        submenu.style.animation = `animateMenuOpen var(--duration-default) ease forwards`;
      });
      details.setAttribute('open', '');
      details.querySelector('summary').setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave(event, details) {
    if (details.classList.contains('mega-menu')) {
      const relatedTarget = event.relatedTarget;
      const isMovingToHeaderMenu = relatedTarget && relatedTarget.closest('header-menu');
      const isMovingWithinDetails = relatedTarget && details.contains(relatedTarget);

      if (isMovingToHeaderMenu) {
        this.close(details);
      } else if (!isMovingWithinDetails) {
        this.megaMenuTimer = setTimeout(() => {
          if (!details.contains(document.activeElement)) {
            this.close(details);
          }
          this.megaMenuTimer = null;
        }, 300);
      }
    } else {
      this.close(details);
    }
  }

  close(details) {
    details?.removeAttribute('open');
    details?.querySelector('summary')?.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle?.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
